import React from 'react';
import { Caption, ImageContainer, Link, SubNewsWrapper } from 'app/components/topNewsModule/subNews/subNewsStyles';
import { Skeleton } from '@mui/material';
import styled from 'styled-components';
import { SIZES } from '@fupa/fupa-uikit';
const TitleSkeleton = styled(Skeleton).withConfig({
  componentId: "sc-203z2d-0"
})(["line-height:", ";"], SIZES['20']);
export default function SubNewsSkeleton(_ref) {
  let {
    animation
  } = _ref;
  return /*#__PURE__*/React.createElement(SubNewsWrapper, {
    "data-sentry-element": "SubNewsWrapper",
    "data-sentry-component": "SubNewsSkeleton",
    "data-sentry-source-file": "SubNewsSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Link, {
    as: "div",
    "data-sentry-element": "Link",
    "data-sentry-source-file": "SubNewsSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    as: Skeleton,
    variant: "rectangular",
    animation: animation,
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "SubNewsSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    width: "50%",
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "SubNewsSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Caption, {
    variant: "caption1",
    "data-sentry-element": "Caption",
    "data-sentry-source-file": "SubNewsSkeleton.tsx"
  }, "Caption")), /*#__PURE__*/React.createElement(TitleSkeleton, {
    variant: "text",
    width: "100%",
    animation: animation,
    "data-sentry-element": "TitleSkeleton",
    "data-sentry-source-file": "SubNewsSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(TitleSkeleton, {
    variant: "text",
    width: "100%",
    animation: animation,
    "data-sentry-element": "TitleSkeleton",
    "data-sentry-source-file": "SubNewsSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(TitleSkeleton, {
    variant: "text",
    width: "100%",
    animation: animation,
    "data-sentry-element": "TitleSkeleton",
    "data-sentry-source-file": "SubNewsSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    width: "40%",
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "SubNewsSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Caption, {
    variant: "caption1",
    "data-sentry-element": "Caption",
    "data-sentry-source-file": "SubNewsSkeleton.tsx"
  }, "Caption"))));
}